var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5133 4.48516C17.5305 2.50234 14.3219 2.50234 12.3414 4.48516L10.0703 6.75625L11.2656 7.95156L13.5367 5.68047C14.7977 4.41953 16.9258 4.28594 18.318 5.68047C19.7125 7.075 19.5789 9.20078 18.318 10.4617L16.0469 12.7328L17.2445 13.9305L19.5156 11.6594C21.4937 9.67656 21.4937 6.46797 19.5133 4.48516ZM10.4641 18.318C9.20312 19.5789 7.075 19.7125 5.68281 18.318C4.28828 16.9234 4.42188 14.7977 5.68281 13.5367L7.95391 11.2656L6.75625 10.068L4.48516 12.3391C2.50234 14.3219 2.50234 17.5305 4.48516 19.5109C6.46797 21.4914 9.67656 21.4937 11.657 19.5109L13.9281 17.2398L12.7328 16.0445L10.4641 18.318ZM6.1 4.90703C6.06476 4.87214 6.01717 4.85256 5.96758 4.85256C5.91798 4.85256 5.8704 4.87214 5.83516 4.90703L4.90703 5.83516C4.87214 5.8704 4.85256 5.91798 4.85256 5.96758C4.85256 6.01717 4.87214 6.06476 4.90703 6.1L17.9008 19.0937C17.9734 19.1664 18.093 19.1664 18.1656 19.0937L19.0937 18.1656C19.1664 18.093 19.1664 17.9734 19.0937 17.9008L6.1 4.90703Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnectIcon.986e9ae941856d9a101bf7d0c2119b82.svg";
export { ForwardRef as ReactComponent };